module.exports = __webpack_public_path__ + "img/storage10.7afe5817.jpg";